import React from 'react';
import classNames from 'classnames';
import AnimatedNumber from 'animated-number-react';

import { Title, Subtitle } from 'components/common';
import { isNil } from 'lib/javascript';

import styles from './Nutrient.module.scss';

const formatNutritionValue = (value) => {
  if (typeof value !== 'number') {
    return '-';
  }

  if (isNaN(value)) {
    return value;
  }

  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  }).format(value);
};

const Nutrient = ({ name, value, unit }) => {
  const nameWithUnit = [name, unit && `(${unit})`]
    .filter((ele) => !isNil(ele))
    .join(' ');

  return (
    <div>
      <Title className={classNames('mb-0', styles.value)}>
        {!isNil(value) ? (
          <AnimatedNumber
            value={value}
            formatValue={(value) => formatNutritionValue(value)}
            duration={350}
          />
        ) : (
          'N/A'
        )}
      </Title>
      <Subtitle className={styles.name}>{nameWithUnit}</Subtitle>
    </div>
  );
};

export default Nutrient;
